(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ghips-scroll-bag"] && !Shopify.designMode) return;
  try {
    
  class GhipsPillowRenderer {
    constructor(host, images) {
      this.host = host;
      this.images = images;
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'ghips-scroll-bag__canvas';
      this.canvas.setAttribute('aria-hidden', 'true');
      this.angle = 0;
      this.disposed = false;
      this.parts = [];
      this.shaders = [];
    }

    async initialize() {
      const sources = await Promise.all(this.images.map(source => new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = source.currentSrc || source.src;
      })));
      if (this.disposed || !this.host.isConnected) return false;
      const gl = this.canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false, powerPreference: 'low-power' });
      if (!gl) return false;
      this.gl = gl;
      const vertexSource = `
        attribute vec3 aPosition;
        attribute vec3 aNormal;
        attribute vec2 aUv;
        uniform float uAngle;
        varying vec2 vUv;
        varying vec3 vNormal;
        void main() {
          float c = cos(uAngle), s = sin(uAngle);
          vec3 p = vec3(c*aPosition.x + s*aPosition.z, aPosition.y, -s*aPosition.x + c*aPosition.z);
          vNormal = vec3(c*aNormal.x + s*aNormal.z, aNormal.y, -s*aNormal.x + c*aNormal.z);
          vUv = aUv;
          float perspective = 8.0 / (8.0 - p.z);
          gl_Position = vec4(p.x * perspective / 1.4, p.y * perspective / 1.919, -p.z / 8.0, 1.0);
        }
      `;
      const fragmentSource = `
        precision mediump float;
        uniform sampler2D uTexture;
        varying vec2 vUv;
        varying vec3 vNormal;
        void main() {
          vec4 color = texture2D(uTexture, vUv);
          if (color.a < 0.35) discard;
          vec3 normal = normalize(vNormal);
          vec3 light = normalize(vec3(-0.35, 0.55, 1.0));
          float shade = 0.80 + 0.20 * max(dot(normal, light), 0.0);
          float sheen = 0.025 * pow(max(dot(normal, normalize(light + vec3(0.0,0.0,1.0))), 0.0), 24.0);
          gl_FragColor = vec4(color.rgb * shade + sheen, color.a);
        }
      `;
      const compile = (type, source) => {
        const shader = gl.createShader(type);
        this.shaders.push(shader);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Bag shader could not compile');
        return shader;
      };
      this.program = gl.createProgram();
      gl.attachShader(this.program, compile(gl.VERTEX_SHADER, vertexSource));
      gl.attachShader(this.program, compile(gl.FRAGMENT_SHADER, fragmentSource));
      gl.linkProgram(this.program);
      if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) throw new Error('Bag shader could not link');
      this.attributes = ['aPosition', 'aNormal', 'aUv'].map(name => gl.getAttribLocation(this.program, name));
      this.angleUniform = gl.getUniformLocation(this.program, 'uAngle');
      this.textureUniform = gl.getUniformLocation(this.program, 'uTexture');
      const balsamic = this.host.dataset.imageProfile === 'balsamic';
      const crops = balsamic
        ? [[424/3072,956/5504,2280/3072,3648/5504],[424/3240,992/5760,2432/3240,3760/5760]]
        : [[595/3375,355/4219,2188/3375,3499/4219],[640/3375,431/4219,2090/3375,3334/4219]];
      const maps = sources.map((image, index) => this.textureMap(image, crops[index], balsamic && index === 1));
      this.parts = maps.map((map, index) => this.makeSurface(map, maps[0], index === 1));
      gl.enable(gl.DEPTH_TEST);
      gl.enable(gl.CULL_FACE);
      gl.cullFace(gl.BACK);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.clearColor(0, 0, 0, 0);
      this.onLost = event => {
        event.preventDefault();
        this.host.classList.remove('has-pillow');
        this.host.dataset.bagSurface = 'fallback';
      };
      this.onRestored = () => {
        if (this.disposed) return;
        this.host.dispatchEvent(new CustomEvent('ghips:restore-bag'));
      };
      this.canvas.addEventListener('webglcontextlost', this.onLost);
      this.canvas.addEventListener('webglcontextrestored', this.onRestored);
      this.host.querySelector('.ghips-scroll-bag__pouch').append(this.canvas);
      this.resizeObserver = new ResizeObserver(() => this.draw(this.angle));
      this.resizeObserver.observe(this.canvas);
      this.host.classList.add('has-pillow');
      this.host.dataset.bagSurface = 'pillow';
      this.draw(this.angle);
      return true;
    }

    maskExterior(imageData, width, height) {
      // Only the supplied Balsamic back has an opaque neutral backdrop. Flood
      // from the outer canvas so the black nutrition text and light print inside
      // the purple pouch remain intact. No color inside the artwork is changed.
      const pixels = imageData.data;
      const visited = new Uint8Array(width * height);
      const queue = new Uint32Array(width * height);
      let head = 0, tail = 0;
      const visit = index => {
        if (visited[index]) return;
        visited[index] = 1;
        const offset = index * 4;
        const red = pixels[offset], green = pixels[offset+1], blue = pixels[offset+2];
        if (pixels[offset+3] < 180 || !(red-green > 10 && blue-green > 4)) {
          pixels[offset+3] = 0;
          queue[tail++] = index;
        }
      };
      for (let x = 0; x < width; x++) { visit(x); visit((height-1)*width+x); }
      for (let y = 1; y < height-1; y++) { visit(y*width); visit(y*width+width-1); }
      while (head < tail) {
        const index = queue[head++], x = index % width;
        if (x > 0) visit(index-1);
        if (x < width-1) visit(index+1);
        if (index >= width) visit(index-width);
        if (index < width*(height-1)) visit(index+width);
      }
    }

    textureMap(image, crop, opaqueBackdrop = false) {
      const canvas = document.createElement('canvas');
      canvas.width = 768;
      canvas.height = 1228;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, crop[0]*image.width, crop[1]*image.height, crop[2]*image.width, crop[3]*image.height, 0, 0, canvas.width, canvas.height);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      if (opaqueBackdrop) {
        this.maskExterior(imageData, canvas.width, canvas.height);
        context.putImageData(imageData, 0, 0);
      }
      const pixels = imageData.data;
      const rows = [];
      for (let y = 0; y < canvas.height; y++) {
        let left = 0, right = canvas.width - 1;
        while (left < right && pixels[(y*canvas.width+left)*4+3] < 180) left++;
        while (right > left && pixels[(y*canvas.width+right)*4+3] < 180) right--;
        rows.push(right-left > 12 ? [left/(canvas.width-1),right/(canvas.width-1)] : null);
      }
      const first = rows.find(row => row !== null) || [0,1];
      let previous = first;
      for (let y = 0; y < rows.length; y++) {
        if (!rows[y]) rows[y] = previous;
        previous = rows[y];
      }
      const sample = v => {
        const y = Math.max(0, Math.min(rows.length-1, v*(rows.length-1)));
        const low = Math.floor(y), high = Math.min(rows.length-1, low+1), f = y-low;
        return [rows[low][0]*(1-f)+rows[high][0]*f, rows[low][1]*(1-f)+rows[high][1]*f];
      };
      return { canvas, sample };
    }

    makeSurface(map, outline, back) {
      const gl = this.gl, columns = 64, rows = 96;
      const vertices = [], indices = [];
      const smooth = (a, b, value) => {
        const t = Math.max(0, Math.min(1, (value-a)/(b-a)));
        return t*t*(3-2*t);
      };
      const position = (u, v) => {
        const [left, right] = outline.sample(v);
        const envelope = smooth(.035,.18,v) * (1-smooth(.82,.965,v));
        const dome = Math.pow(Math.max(0, Math.sin(Math.PI*v)), .8);
        const depth = .26 * Math.pow(Math.max(0, Math.sin(Math.PI*u)), .75) * envelope * dome;
        return [(left+(right-left)*u)*2-1, (0.5-v)*3.19835466, back ? -depth : depth];
      };
      for (let y = 0; y <= rows; y++) {
        const v = y/rows;
        const [left, right] = map.sample(v);
        for (let x = 0; x <= columns; x++) {
          const u = x/columns, p = position(u,v), epsilon = .0005;
          const a = position(Math.max(0,u-epsilon),v), b = position(Math.min(1,u+epsilon),v);
          const c = position(u,Math.max(0,v-epsilon)), d = position(u,Math.min(1,v+epsilon));
          const du = b.map((n,i)=>n-a[i]), dv = d.map((n,i)=>n-c[i]);
          let normal = [dv[1]*du[2]-dv[2]*du[1],dv[2]*du[0]-dv[0]*du[2],dv[0]*du[1]-dv[1]*du[0]];
          const length = Math.hypot(...normal) || 1;
          normal = normal.map(n => n/length*(back ? -1 : 1));
          const textureU = left+(right-left)*(back ? 1-u : u);
          vertices.push(...p,...normal,textureU,1-v);
          if (x < columns && y < rows) {
            const i = y*(columns+1)+x, j = i+columns+1;
            if (back) indices.push(i,i+1,j,i+1,j+1,j);
            else indices.push(i,j,i+1,i+1,j,j+1);
          }
        }
      }
      const vertexBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
      const indexBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
      const texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,map.canvas);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
      return { vertexBuffer, indexBuffer, texture, count: indices.length };
    }

    draw(angle) {
      this.angle = angle;
      const gl = this.gl;
      if (this.disposed || !gl || gl.isContextLost() || !this.program) return;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1,Math.round(this.canvas.clientWidth*ratio));
      const height = Math.max(1,Math.round(this.canvas.clientHeight*ratio));
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width;
        this.canvas.height = height;
      }
      gl.viewport(0,0,width,height);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.useProgram(this.program);
      gl.uniform1f(this.angleUniform,angle*Math.PI/180);
      gl.uniform1i(this.textureUniform,0);
      gl.activeTexture(gl.TEXTURE0);
      for (const part of this.parts) {
        gl.bindBuffer(gl.ARRAY_BUFFER,part.vertexBuffer);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,part.indexBuffer);
        this.attributes.forEach((attribute,i) => {
          gl.enableVertexAttribArray(attribute);
          gl.vertexAttribPointer(attribute,i === 2 ? 2 : 3,gl.FLOAT,false,32,i === 0 ? 0 : i === 1 ? 12 : 24);
        });
        gl.bindTexture(gl.TEXTURE_2D,part.texture);
        gl.drawElements(gl.TRIANGLES,part.count,gl.UNSIGNED_SHORT,0);
      }
    }

    dispose() {
      this.disposed = true;
      this.resizeObserver?.disconnect();
      this.canvas.removeEventListener('webglcontextlost',this.onLost);
      this.canvas.removeEventListener('webglcontextrestored',this.onRestored);
      if (this.gl && !this.gl.isContextLost()) {
        for (const part of this.parts) {
          this.gl.deleteBuffer(part.vertexBuffer);
          this.gl.deleteBuffer(part.indexBuffer);
          this.gl.deleteTexture(part.texture);
        }
        if (this.program) this.gl.deleteProgram(this.program);
        for (const shader of this.shaders) this.gl.deleteShader(shader);
        this.gl.getExtension('WEBGL_lose_context')?.loseContext();
      }
      this.canvas.remove();
      if (this.host.surface === this) this.host.classList.remove('has-pillow');
    }
  }

  if (!customElements.get('ghips-scroll-bag')) {
    customElements.define('ghips-scroll-bag', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.frame = 0;
        if (!this.isConnected || this.dataset.hasBack !== 'true') return;
        this.product = this.querySelector('.ghips-scroll-bag__product');
        this.button = this.querySelector('.ghips-scroll-bag__toggle');
        if (!this.product || !this.button) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.duration = Math.max(12, Number(this.dataset.rotationDuration) || 24) * 1000;
        this.angle = Number(this.angle) || 0;
        this.paused = Boolean(this.paused);
        this.active = false;
        this.resumeAt = 0;
        this.pointer = null;
        this.product.setAttribute('tabindex', '0');
        this.product.setAttribute('role', 'slider');
        this.product.setAttribute('aria-label', this.product.dataset.rotationLabel);
        this.product.setAttribute('aria-describedby', this.product.dataset.helpId);
        this.product.setAttribute('aria-orientation', 'horizontal');
        this.product.setAttribute('aria-valuemin', '0');
        this.product.setAttribute('aria-valuemax', '360');
        this.onDown = event => this.startDrag(event);
        this.onMove = event => this.drag(event);
        this.onEnd = event => this.endDrag(event);
        this.onKey = event => this.keyRotate(event);
        this.onToggle = () => {
          this.paused = !this.paused;
          this.resumeAt = 0;
          this.rampNext = true;
          this.sync();
        };
        this.onMotion = () => this.sync();
        this.onVisibility = () => {
          if (document.hidden && this.pointer) this.endDrag({ pointerId: this.pointer.id });
          this.sync();
        };
        this.product.addEventListener('pointerdown', this.onDown);
        this.product.addEventListener('pointermove', this.onMove);
        this.product.addEventListener('pointerup', this.onEnd);
        this.product.addEventListener('pointercancel', this.onEnd);
        this.product.addEventListener('lostpointercapture', this.onEnd);
        this.product.addEventListener('keydown', this.onKey);
        this.button.addEventListener('click', this.onToggle);
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.classList.add('is-enhanced');
        this.render();
        this.onRestoreBag = () => this.prepareSurface();
        this.addEventListener('ghips:restore-bag', this.onRestoreBag);
        this.prepareSurface();
        this.observer = new IntersectionObserver(entries => {
          this.active = entries.some(entry => entry.isIntersecting);
          this.sync();
        });
        this.observer.observe(this);
        this.sync();
      }

      prepareSurface() {
        this.surface?.dispose();
        const images = ['.ghips-scroll-bag__face--front img', '.ghips-scroll-bag__face--back img'].map(selector => this.querySelector(selector));
        if (images.some(image => !image)) return;
        const surface = new GhipsPillowRenderer(this, images);
        this.surface = surface;
        this.dataset.bagSurface = 'loading';
        surface.initialize().then(ready => {
          if (this.surface !== surface || !this.isConnected) { surface.dispose(); return; }
          if (!ready) { surface.dispose(); this.dataset.bagSurface = 'fallback'; }
          else surface.draw(this.angle);
        }).catch(() => {
          surface.dispose();
          if (this.surface === surface) this.dataset.bagSurface = 'fallback';
        });
      }

      canAnimate() {
        return this.isConnected && this.active && !document.hidden && !this.paused && !this.motion.matches && !this.pointer;
      }

      sync() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resumeTimer);
        this.frame = 0;
        this.resumeTimer = 0;
        this.lastTime = null;
        this.classList.remove('is-rotating');
        this.button.disabled = this.motion.matches;
        this.button.textContent = this.motion.matches ? this.button.dataset.reducedLabel : this.paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel;
        if (!this.canAnimate()) return;
        const wait = this.resumeAt - performance.now();
        if (wait > 0) {
          this.resumeTimer = setTimeout(() => this.sync(), wait);
          return;
        }
        this.classList.add('is-rotating');
        this.frame = requestAnimationFrame(time => this.tick(time));
      }

      tick(time) {
        this.frame = 0;
        if (!this.canAnimate()) {
          this.lastTime = null;
          this.classList.remove('is-rotating');
          return;
        }
        if (this.lastTime === null) {
          this.rampStart = this.rampNext ? time : null;
          this.rampNext = false;
        } else {
          const delta = Math.max(0, Math.min(100, time - this.lastTime));
          const ramp = this.rampStart === null ? 1 : Math.min(1, (time - this.rampStart) / 600);
          this.angle += delta * 360 / this.duration * ramp;
          this.render();
        }
        this.lastTime = time;
        this.frame = requestAnimationFrame(next => this.tick(next));
      }

      render() {
        this.angle = ((this.angle % 360) + 360) % 360;
        this.style.setProperty('--gsb-angle', `${this.angle.toFixed(2)}deg`);
        this.surface?.draw(this.angle);
        this.style.setProperty('--gsb-shadow', (.5 + Math.abs(Math.cos(this.angle * Math.PI / 180)) * .5).toFixed(3));
        const value = String(Math.round(this.angle));
        if (this.product.getAttribute('aria-valuenow') !== value) this.product.setAttribute('aria-valuenow', value);
      }

      startDrag(event) {
        if (this.pointer || event.isPrimary === false || event.button > 0) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, angle: this.angle, type: event.pointerType, horizontal: false };
        this.classList.add('is-dragging');
        this.product.focus({ preventScroll: true });
        try { this.product.setPointerCapture(event.pointerId); } catch (error) {}
        if (event.pointerType === 'mouse') event.preventDefault();
        this.sync();
      }

      drag(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        if (!this.pointer.horizontal) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
          if (this.pointer.type !== 'mouse' && Math.abs(dy) > Math.abs(dx)) {
            this.endDrag(event);
            return;
          }
          this.pointer.horizontal = true;
        }
        const width = Math.max(180, this.product.getBoundingClientRect().width);
        this.angle = this.pointer.angle + dx / width * 180;
        this.render();
      }

      endDrag(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const id = this.pointer.id;
        this.pointer = null;
        this.classList.remove('is-dragging');
        try {
          if (this.product.hasPointerCapture(id)) this.product.releasePointerCapture(id);
        } catch (error) {}
        this.resumeAt = performance.now() + 4000;
        this.rampNext = true;
        this.sync();
      }

      keyRotate(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home'].includes(event.key)) return;
        event.preventDefault();
        const step = event.shiftKey ? 45 : 15;
        this.angle = event.key === 'Home' ? 0 : this.angle + (event.key === 'ArrowLeft' ? -step : step);
        this.render();
        this.resumeAt = performance.now() + 4000;
        this.rampNext = true;
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('ghips:restore-bag', this.onRestoreBag);
        this.surface?.dispose();
        this.surface = null;
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resumeTimer);
        this.frame = 0;
        this.resumeTimer = 0;
        this.observer?.disconnect();
        if (this.product) {
          this.product.removeEventListener('pointerdown', this.onDown);
          this.product.removeEventListener('pointermove', this.onMove);
          this.product.removeEventListener('pointerup', this.onEnd);
          this.product.removeEventListener('pointercancel', this.onEnd);
          this.product.removeEventListener('lostpointercapture', this.onEnd);
          this.product.removeEventListener('keydown', this.onKey);
          if (this.pointer) {
            try { this.product.releasePointerCapture(this.pointer.id); } catch (error) {}
          }
        }
        this.pointer = null;
        this.button?.removeEventListener('click', this.onToggle);
        this.motion?.removeEventListener('change', this.onMotion);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        this.classList.remove('is-rotating');
        this.classList.remove('is-dragging');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
